module.exports = __webpack_public_path__ + "img/wallet4good_reverse.9639b551.svg";